import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AboutDialogComponent } from './about-dialog.component';

@Component({
  selector: 'hb-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  constructor(public bsModalRef: BsModalRef, private modalService: BsModalService) { }

  ngOnInit() { }

  public showAboutDialog() {
    this.bsModalRef = this.modalService.show(AboutDialogComponent);
  }
}
